import React from "react";
import TagsTable from "./TagsTable";

class Tags extends React.Component {
    constructor() {
        super();
        this.state = {
            data: [],
            loading: true,
            errorMsg: '',
        };
    }

    saveRequest() {
        const getToken = localStorage.getItem("token");
        const inpersonate = localStorage.getItem("inpersonate");
        const userId = localStorage.getItem("userId");
        const inpersonateId = localStorage.getItem("inpersonate_id");
        const userIdToShow = (inpersonate === 'true') ? inpersonateId : userId;
        const userRole = localStorage.getItem("userRole");
        let requestOptions = {
            method: "GET",
            mode: "cors",
            headers: {
                'Authorization': 'Bearer ' + getToken,
            },
        };

        if (userRole === "1" && inpersonate === "false") {
            fetch(`./wp-json/asd/tag/configs/get`, requestOptions)
                .then(response => response.json())
                .then(responseData => {
                    if (!responseData.hasOwnProperty('code')) {
                        this.setState({data: responseData, loading: false});
                    } else {
                        let errorMessage = `Error: ${responseData.message}`
                        this.setState({errorMsg: errorMessage, loading: false});
                    }
                })
        } else {
            fetch(`./wp-json/asd/api/source/get?user-id=${userIdToShow}`, requestOptions)
                .then(response => response.json())
                .then(sourceData => {
                    if (sourceData.code === 200 && sourceData.data.length > 0) {
                        const sourcesString = sourceData.data.toString();
                        const sourcesEndpoint = sourcesString.replace(/^/, 'utm-source[]=');

                        this.partnerApiRequest(requestOptions, sourcesEndpoint);
                    } else {
                        let errorMessage = sourceData.data ? 'No Configurations Available!' : `Error: ${sourceData.message}`
                        this.setState({errorMsg: errorMessage, loading: false});
                    }
                })
        }
    }

    partnerApiRequest(requestOptions, sourcesEndpoint) {
        fetch(`/wp-json/asd/tag/configs/get?${sourcesEndpoint}`, requestOptions)
            .then(response => response.json())
            .then(responseData => {
                if (!responseData.hasOwnProperty('code')) {
                    this.setState({data: responseData, loading: false});
                } else {
                    let errorMessage = `Error: ${responseData.message}`
                    this.setState({errorMsg: errorMessage, loading: false});
                }
            })
    }

    componentDidMount() {
        const selectedTabNum = 3
        if (selectedTabNum === this.props.SelectedTab) {
            this.saveRequest();
        }
    }

    render() {
        return <TagsTable
            data={this.state.data}
            loading={this.state.loading}
            errorMsg={this.state.errorMsg}
            saveRequest={this.saveRequest.bind(this)}
        />
    }
}

export default Tags;

